// src/utils/idle.ts — FINAL
export type IdleDeadline = { timeRemaining: () => number; didTimeout: boolean };
export const idle = (cb: (d: IdleDeadline) => void) =>
    "requestIdleCallback" in window
        ? (window as any).requestIdleCallback(cb, { timeout: 1000 })
        : setTimeout(
              () => cb({ timeRemaining: () => 10, didTimeout: true }),
              50,
          );
